var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "giftcode-exchange" },
    [
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "login__form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "div",
            { staticClass: "user d-none" },
            [
              _vm.isAuthenticated
                ? _c("v-text-field", {
                    staticClass: "login__input",
                    attrs: {
                      rules: _vm.nameRules,
                      label: "Tên tài khoản",
                      outlined: "",
                      disabled: "",
                      required: "",
                      height: "40px",
                      dense: "",
                    },
                    model: {
                      value: _vm.username,
                      callback: function ($$v) {
                        _vm.username = $$v
                      },
                      expression: "username",
                    },
                  })
                : _c("v-text-field", {
                    staticClass: "login__input",
                    attrs: {
                      rules: _vm.nameRules,
                      label: "Tên tài khoản",
                      outlined: "",
                      required: "",
                      height: "40px",
                      dense: "",
                    },
                    model: {
                      value: _vm.name,
                      callback: function ($$v) {
                        _vm.name = $$v
                      },
                      expression: "name",
                    },
                  }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "gametitle" },
            [
              !this.$route.params.id
                ? _c("v-select", {
                    ref: "gameName",
                    staticClass: "login__input",
                    attrs: {
                      items: _vm.gameTitle,
                      rules: _vm.gameRules,
                      label: "Danh sách game",
                      outlined: "",
                      required: "",
                      height: "40px",
                      dense: "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.gameSelect(_vm.selected)
                      },
                    },
                    model: {
                      value: _vm.selected,
                      callback: function ($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.can_use_code === true
            ? _c("v-select", {
                ref: "group_server",
                staticClass: "login__input",
                attrs: {
                  items: _vm.group_name,
                  "item-text": "name",
                  rules: _vm.groupRules,
                  label: "Chọn cụm server",
                  outlined: "",
                  required: "",
                  height: "40px",
                  dense: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.groupServerSelect(_vm.group_server)
                  },
                },
                model: {
                  value: _vm.group_server,
                  callback: function ($$v) {
                    _vm.group_server = $$v
                  },
                  expression: "group_server",
                },
              })
            : _vm._e(),
          _vm.can_use_code === true
            ? _c("v-select", {
                ref: "server",
                staticClass: "login__input",
                attrs: {
                  items: _vm.servers,
                  "item-text": "name",
                  rules: _vm.serverRules,
                  label: "Chọn máy chủ",
                  outlined: "",
                  required: "",
                  height: "40px",
                  dense: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.serverSelect(_vm.server)
                  },
                },
                model: {
                  value: _vm.server,
                  callback: function ($$v) {
                    _vm.server = $$v
                  },
                  expression: "server",
                },
              })
            : _vm._e(),
          _vm.can_use_code === true
            ? _c("v-select", {
                ref: "character",
                staticClass: "login__input",
                attrs: {
                  items: _vm.characters,
                  "item-text": "name",
                  rules: _vm.characterRules,
                  label: "Danh sách nhân vật",
                  outlined: "",
                  required: "",
                  height: "40px",
                  dense: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.characterSelect(_vm.character)
                  },
                },
                model: {
                  value: _vm.character,
                  callback: function ($$v) {
                    _vm.character = $$v
                  },
                  expression: "character",
                },
              })
            : _vm._e(),
          _vm.can_use_code === true
            ? _c("div", { staticClass: "codegame" }, [
                this.code_game !== "" && this.$route.params.id
                  ? _c(
                      "div",
                      {
                        staticClass: "code-game",
                        staticStyle: { position: "relative" },
                      },
                      [
                        _c("v-text-field", {
                          ref: "codeId",
                          staticClass: "login__input",
                          attrs: {
                            rules: _vm.codeRules,
                            label: "Nhập Giftcode",
                            outlined: "",
                            required: "",
                            height: "40px",
                            dense: "",
                            disabled: "",
                          },
                          model: {
                            value: _vm.code_game,
                            callback: function ($$v) {
                              _vm.code_game = $$v
                            },
                            expression: "code_game",
                          },
                        }),
                        _c(
                          "v-btn",
                          {
                            staticClass: "copy-btn pa-0",
                            attrs: { depressed: "", text: "" },
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                directives: [
                                  {
                                    name: "clipboard",
                                    rawName: "v-clipboard:copy",
                                    value: _vm.code_game,
                                    expression: "code_game",
                                    arg: "copy",
                                  },
                                ],
                              },
                              [_vm._v("mdi-content-copy")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "code",
                        staticStyle: { position: "relative" },
                      },
                      [
                        _c("v-text-field", {
                          ref: "code",
                          staticClass: "login__input",
                          attrs: {
                            rules: _vm.codeRules,
                            label: "Nhập Giftcode",
                            outlined: "",
                            required: "",
                            height: "40px",
                            dense: "",
                          },
                          model: {
                            value: _vm.code,
                            callback: function ($$v) {
                              _vm.code = $$v
                            },
                            expression: "code",
                          },
                        }),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "recaptcha" }, [
            _c(
              "div",
              { staticClass: "d-flex justify-center" },
              [
                _c("vue-recaptcha", {
                  attrs: {
                    "v-model": _vm.rcaptcha,
                    sitekey: _vm.sitekey,
                    loadRecaptchaScript: true,
                  },
                  on: { verify: _vm.verifyMethod },
                }),
              ],
              1
            ),
            _vm.recaptchaAlert
              ? _c("span", { staticClass: "recaptcha__alert" }, [
                  _vm._v("Vui lòng xác nhận không phải là robot"),
                ])
              : _vm._e(),
          ]),
          _vm.can_use_code === true
            ? _c(
                "v-btn",
                {
                  staticClass: "login__btn login__btn--id text-none mt-0",
                  attrs: { disabled: !_vm.valid, color: "#ccc", outlined: "" },
                  on: { click: _vm.validate },
                },
                [_vm._v(" Tiếp tục ")]
              )
            : _vm._e(),
          _c("div", { staticClass: "giftcode-exchange__desc" }, [
            _vm.can_use_code === true
              ? _c("div", [
                  _c("p", [
                    _vm._v(
                      " 1. Quà sẽ được gửi vào thư trong game khi nhập Giftcode thành công. "
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " 2. Lưu ý các nguyên nhân có thể dẫn tới việc nhập Giftcode không thành công như: Nhập thiếu ký tự, nhầm 2 ký tự gần giống nhau, hết hạn Giftcode... "
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " 3. Các game không hỗ trợ đổi code sẽ không xuất hiện khi chọn game. Vui lòng đổi trong game! "
                    ),
                  ]),
                ])
              : _c("div", [
                  _c("p", [
                    _vm._v(
                      " Game này hiện tại chưa hỗ trợ đổi code trên trang giftcode. Vui lòng đổi trong game hoặc thử lại sau! "
                    ),
                  ]),
                ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }